import '../CsvJsonInfoPages.scss';


function GenericStatus() {

    const data = [
        { field: 1, description: 'CAP ID (Int)' },
        { field: 2, description: 'Generic Code (Int)' },
        { field: 3, description: 'Effective From Date (Date)' },
        { field: 4, description: 'Effective To Date (Date)' },
        { field: 5, description: 'Generic Status (Char)' },
    ];



    return (
        <div className='csv-json-info-pages-container'>
            <h1>New Vehicle Data Enhanced - Generic Status</h1>
            <p>This file contains the status of each generic item for a given CAP iD.<br /><br />
                <b>File Naming Convention</b><br /><br />
                The Filename is dependant on the product being produced as follows.<br /><br />

                CAR_yyyy-mm-dd_NVDGenericStatus.txt<br />
                LIGHTS_yyyy-mm-dd_NVDGenericStatus.txt<br />
                HEAVIES_yyyy-mm-dd_NVDGenericStatus.txt<br />
                BIKES_yyyy-mm-dd_NVDGenericStatus.txt<br /><br />

                Note: yyyy-mm-dd represents the date of the product. E.g. 2003-07-01 would represent the date 1st July 2003.
            </p>
            <table>
                <thead>
                    <tr>
                        <th>Field</th>
                        <th>DATA</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, index) => (
                        <tr key={index}>
                            <td>{item.field}</td>
                            <td>{item.description}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <p>
                The generic status can be one of the following values:<br/>
                S - Standard Equipment<br/>
                O - Cost Option<br/>
                N - Not available<br/>
                U - Unresearched
            </p>
        </div>
    );
}

export default GenericStatus;
